export default [
  {
    id: 8,
    parent: 0,
    value: '游戏',
    level: '1',
    children: [
      {
        id: 802,
        parent: 8,
        value: '游戏（按题材）',
        level: '2',
        children: [
          {
            id: 80201,
            parent: 802,
            value: '传奇游戏',
            level: '3'
          },
          {
            id: 80202,
            parent: 802,
            value: '仙侠游戏',
            level: '3'
          },
          {
            id: 80203,
            parent: 802,
            value: '魔幻游戏',
            level: '3'
          },
          {
            id: 80204,
            parent: 802,
            value: '西游游戏',
            level: '3'
          },
          {
            id: 80205,
            parent: 802,
            value: '三国游戏',
            level: '3'
          },
          {
            id: 80206,
            parent: 802,
            value: '宫廷游戏（女性向）',
            level: '3'
          },
          {
            id: 80207,
            parent: 802,
            value: '都市游戏',
            level: '3'
          },
          {
            id: 80208,
            parent: 802,
            value: '末日游戏',
            level: '3'
          },
          {
            id: 80209,
            parent: 802,
            value: '盗墓游戏',
            level: '3'
          },
          {
            id: 80210,
            parent: 802,
            value: '科幻游戏',
            level: '3'
          },
          {
            id: 80211,
            parent: 802,
            value: '二次元游戏',
            level: '3'
          },
          {
            id: 80212,
            parent: 802,
            value: '女性向游戏',
            level: '3'
          },
          {
            id: 80214,
            parent: 802,
            value: '游戏题材其他',
            level: '3'
          },
          {
            id: 80215,
            parent: 802,
            value: '军事游戏',
            level: '3'
          },
          {
            id: 80216,
            parent: 802,
            value: '宫廷游戏（男性向）',
            level: '3'
          }
        ]
      },
      {
        id: 803,
        parent: 8,
        value: '游戏（按利益）',
        level: '2',
        children: [
          {
            id: 80301,
            parent: 803,
            value: '网赚游戏',
            level: '3'
          },
          {
            id: 80302,
            parent: 803,
            value: '游戏利益其他',
            level: '3'
          }
        ]
      }
    ]
  }
]
